module.exports = __webpack_public_path__ + "img/Mockup_0_small.2a1ea74a.jpg";